import React from "react";
import { CircleSectionItem } from "../circleSectionItem/CircleSectionItem";
import "./CircleSectionsList.css";
import { observer } from "mobx-react-lite";
import { useSelectCircleStore } from "../../stores/StoreContext";

export const CircleSectionsList: React.FC = observer(() => {
  const selectCircleStore = useSelectCircleStore();

  const [activeIndex, setActiveIndex] = React.useState(0);
  const scrollContainerRef = React.useRef<HTMLDivElement>(null);

  // Function to navigate to the next section
  const goToNextSection = () => {
    if (activeIndex < selectCircleStore.selectedCircles.length - 1) {
      setActiveIndex(activeIndex + 1);
    }
  };

  // Function to navigate to the previous section
  const goToPrevSection = () => {
    if (activeIndex > 0) {
      setActiveIndex(activeIndex - 1);
    }
  };

  // Update scroll position when activeIndex changes
  React.useEffect(() => {
    if (scrollContainerRef.current) {
      const scrollAmount = activeIndex * scrollContainerRef.current.offsetWidth;
      scrollContainerRef.current.scrollTo({
        left: scrollAmount,
        behavior: "smooth",
      });
    }
  }, [activeIndex]);

  return selectCircleStore.selectedCircles.length ? (
    <div className="circle-sections-container">
      <div className="circle-sections-scroll" ref={scrollContainerRef}>
        {selectCircleStore.selectedCircles.map((section, index) => (
          <CircleSectionItem
            key={section}
            id={section}
            index={index}
            onNextClick={goToNextSection}
            onPrevClick={goToPrevSection}
          />
        ))}
      </div>
    </div>
  ) : null;
});
